import { createContext, useEffect, useState } from "react";
import { rotateRowsDate } from "../tools/utilities";
import getUrl from "../tools/get-domain";

export const Context = createContext();

export function ContextProvider({ children }) {
    const [refresh, setRefresh] = useState()

    const showSelectedSymbols = JSON.parse(localStorage.getItem('showSelectedSymbols'))
    const selectedStocks = JSON.parse(localStorage.getItem('selectedStocks'))
    const selectedSymbols = JSON.parse(localStorage.getItem('selectedSymbols')) ? JSON.parse(localStorage.getItem('selectedSymbols')) : []
    const trend = [1, 2, 3].includes(JSON.parse(localStorage.getItem('trend'))) ? JSON.parse(localStorage.getItem('trend')) : 1
    const searchedSymbols = JSON.parse(localStorage.getItem('searchedSymbols'))

    const [contextData, setContextData] = useState({
        rows: [],
        refresh: false,
        showSelectedSymbols: showSelectedSymbols,
        trend: trend,
        selectedSymbols: selectedSymbols,
        searchedSymbols: searchedSymbols,
        selectedStocks: selectedStocks
    });

    useEffect(() => {
        async function fetchData() {
            const url = getUrl().REACT_APP_CTCROSS
            try {
                const response = await fetch(url)
                if (!response.ok) {
                    updateContextKey('rows', false)
                }
                const rows = await response.json();
                updateContextKey('rows', rows)
            } catch (e) {
                updateContextKey('rows', false)
            }
        }

        rotateRowsDate()
        fetchData()

        const date = new Date();
        const today = date.getDay();
        const hour = date.getHours();
        setInterval(() => {
            if ([4, 5].indexOf(today) < 0 && hour > 8 && hour < 13) {
                rotateRowsDate()
                fetchData()
            }
        }, 20000);

    }, [refresh]);

    const updateContextKey = (key, newValue) => {
        setContextData((prevData) => ({
            ...prevData,
            [key]: newValue,
        }));
    };

    const updateRefresh = () => {
        setRefresh(!refresh)
    };

    const updateShowSelectedSymbols = () => {
        const current = !showSelectedSymbols
        updateContextKey('showSelectedSymbols', current);
        localStorage.setItem('showSelectedSymbols', JSON.stringify(current))
    };


    const updateTrend = (newTrend) => {
        updateContextKey('trend', newTrend);
        localStorage.setItem('trend', JSON.stringify(newTrend))
    };

    const updateSearchSymbol = (newSearchedSymbols) => {
        updateContextKey('searchedSymbols', newSearchedSymbols);
        localStorage.setItem('searchedSymbols', JSON.stringify(newSearchedSymbols))
    };


    const updateSelectedSymbols = (selectedSymbols) => {
        const selectSymbolsKeyName = 'selectedSymbols'
        // Step 1: Get the previously selected symbols from localStorage
        const selectedSymbolsFromLocalStorage = JSON.parse(localStorage.getItem(selectSymbolsKeyName)) || [];
        // Step 2: Concatenate with newlySelectedOptions
        const concatenatedSymbols = selectedSymbolsFromLocalStorage.concat(selectedSymbols);
        // Step 3: Remove duplicates from the concatenated array
        const uniqueSymbols = [...new Set(concatenatedSymbols)];
        // Step 4: Store the deduplicated array back into localStorage
        localStorage.setItem(selectSymbolsKeyName, JSON.stringify(uniqueSymbols));
        // step 5: update the "selectedSymbols" value in contextData
        updateContextKey('selectedSymbols', uniqueSymbols);
    };

    const updateSelectedStocks = (selectedItems) => {
        localStorage.setItem('selectedStocks', JSON.stringify(selectedItems));
        updateContextKey('selectedStocks', selectedItems);
    }

    const updateSortKey = (sortObject) => {
        localStorage.setItem('sort', JSON.stringify(sortObject))
        updateContextKey('sort', sortObject)
    }


    return (
        <Context.Provider
            value={{
                contextData,
                updateContextKey,
                updateSelectedSymbols: updateSelectedSymbols,
                updateShowSelectedSymbols: updateShowSelectedSymbols,
                updateTrend: updateTrend,
                updateSearchSymbol: updateSearchSymbol,
                updateRefresh: updateRefresh,
                updateSelectedStocks: updateSelectedStocks,
                updateSortKey: updateSortKey
            }}
        >
            {children}
        </Context.Provider>
    );
}
